import { render, staticRenderFns } from "./JudgingCriteriaQuestionsCreate.vue?vue&type=template&id=7a3431d8&scoped=true"
import script from "./JudgingCriteriaQuestionsCreate.vue?vue&type=script&lang=js"
export * from "./JudgingCriteriaQuestionsCreate.vue?vue&type=script&lang=js"
import style0 from "./JudgingCriteriaQuestionsCreate.vue?vue&type=style&index=0&id=7a3431d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3431d8",
  null
  
)

export default component.exports